export const PROFILE_PAGE_TRANSLATION_KEYS = {
    personalSectionTitle: 'personalSection.title',
    languageSectionTitle: 'languageSection.title',
    personalFields: {
        firstNameLabel: 'personalSection.fields.firstName.label',
        firstNameEmpty: 'personalSection.fields.firstName.empty',
        lastNameLabel: 'personalSection.fields.lastName.label',
        lastNameEmpty: 'personalSection.fields.lastName.empty',
        usernameLabel: 'personalSection.fields.username.label',
        primaryEmailLabel: 'personalSection.fields.primaryEmail.label',
        primaryEmailEmpty: 'personalSection.fields.primaryEmail.empty',
        secondaryEmailLabel: 'personalSection.fields.secondaryEmail.label',
        secondaryEmailEmpty: 'personalSection.fields.secondaryEmail.empty',
        phoneLabel: 'personalSection.fields.phone.label'
    },
    languageFieldLabel: 'languageSection.fieldLabel'
};
